"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeFreshdeskWidget = void 0;
const FRESHDESK_SCRIPT_ID = 'Freshdesk-js-sdk';
const FRESHDESK_SCRIPT_SRC = 'https://pleohelp.freshdesk.com/webchat/js/widget.js';
const FRESHDESK_CONFIG = {
    token: '01K9S5SPZTFX5CAX9CCT0DTHE4',
    host: 'https://pleohelp.freshdesk.com',
    widgetId: '01KXZP9JACHP02B9R463NYQGKG',
};
const initFreshdesk = () => {
    window.fdWidget.init(FRESHDESK_CONFIG);
};
const injectFreshdeskScript = () => {
    if (document.getElementById(FRESHDESK_SCRIPT_ID)) {
        if (window.fdWidget) {
            initFreshdesk();
        }
        return;
    }
    const script = document.createElement('script');
    script.id = FRESHDESK_SCRIPT_ID;
    script.async = true;
    script.src = FRESHDESK_SCRIPT_SRC;
    script.onload = initFreshdesk;
    document.head.appendChild(script);
};
/**
 * Loads the CX-provided Freshdesk chatbot widget, injecting immediately if the page has already
 * finished loading (e.g. after client-side navigation), or once the window finishes loading
 * otherwise. Called unconditionally for every locale and environment — no caller-side gating.
 */
const initializeFreshdeskWidget = () => {
    if (document.readyState === 'complete') {
        injectFreshdeskScript();
    }
    else {
        window.addEventListener('load', injectFreshdeskScript, { once: true });
    }
};
exports.initializeFreshdeskWidget = initializeFreshdeskWidget;
